export default function initWastePassRequest() {
    window.addEventListener('DOMContentLoaded', () => {
        const wastePassRequestForm = document.querySelector('form[id^="waste-pass-request"]');
        if (wastePassRequestForm) {
            const reasonSelect = wastePassRequestForm.querySelector('#reason-for-request');
            const formGroupPayNow = wastePassRequestForm.querySelector('[data-form-group-pay-now]');
            reasonSelect.addEventListener('change', (event) => {
                switch (event.target.value) {
                case 'Afvalpas kwijtgeraakt / beschadigd':
                    formGroupPayNow.classList.remove('hidden');
                    break;
                default:
                    formGroupPayNow.classList.add('hidden');
                    break;
                }
            });

            // Scroll to form when form has errors
            const wastePassRequestFormErrors = wastePassRequestForm.querySelectorAll('.text-danger').length;
            if (wastePassRequestFormErrors > 0) {
                wastePassRequestForm.scrollIntoView();
            }
        }
    });
}
